<template>

    <content menu="成果总结"  :location = "['成果总结']"> 
       <pdfPlayer pdfUrl = './files/achievement_summarize.pdf'  ></pdfPlayer>	
    </content>

</template>


<script>
import content from './content.vue'
import pdfPlayer from "../exhibition/pdfPlayer.vue"
	export default {
		name:"ApplicationForm",
        components:{
            content,
            pdfPlayer
        },
		props:{
		},
		data() {
			return {
                
			};
		},
		methods:{
		},
	}
</script>

<style lang="scss" scoped>
</style>
